import React, { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useBranding } from "@/lib/branding";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import PoweredBy from "@/components/PoweredBy";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const { branding } = useBranding();
  const [token, setToken] = useState(params.get("token") || "");
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 8) return toast.error("Password must be at least 8 characters");
    if (password !== confirm) return toast.error("Passwords don't match");
    if (!token.trim()) return toast.error("Reset code required");
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token: token.trim(), new_password: password });
      toast.success("Password reset — please sign in");
      nav("/login");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Reset failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-background paper-texture grid place-items-center p-6">
      <form onSubmit={submit} className="max-w-md w-full bg-card border border-border rounded-md p-8" data-testid="reset-password-form">
        <div className="label-caps mb-2">{branding.brand_name}</div>
        <h1 className="font-serif text-4xl mb-2">Set a new password.</h1>
        <p className="text-sm text-muted-foreground mb-6">
          Paste the reset code your instructor gave you, then choose a new password.
        </p>

        <div className="space-y-4">
          <div>
            <Label htmlFor="rp-token">Reset code</Label>
            <Input id="rp-token" data-testid="reset-token-input" value={token} onChange={e => setToken(e.target.value)} placeholder="Paste code from your instructor" />
          </div>
          <div>
            <Label htmlFor="rp-password">New password</Label>
            <Input id="rp-password" data-testid="reset-password-input" type="password" value={password} onChange={e => setPassword(e.target.value)} minLength={8} required />
          </div>
          <div>
            <Label htmlFor="rp-confirm">Confirm new password</Label>
            <Input id="rp-confirm" data-testid="reset-confirm-input" type="password" value={confirm} onChange={e => setConfirm(e.target.value)} minLength={8} required />
          </div>
          <Button type="submit" disabled={loading} className="w-full" data-testid="reset-submit-btn">
            {loading ? "Setting password…" : "Reset password"}
          </Button>
          <div className="text-center">
            <Link to="/login" className="text-xs underline text-muted-foreground" data-testid="reset-back-login">Back to sign in</Link>
          </div>
        </div>

        <PoweredBy className="mt-6 text-center" />
      </form>
    </div>
  );
}
